import { Component, OnInit ,ViewChild,ElementRef} from "@angular/core";
import { Router, ActivatedRoute } from '@angular/router';
import CryptoJS from 'crypto-js';
import { QuizService } from '../../Service/Quizservice';
import { StudentresponsePage } from "../pages/Student/Studentresponse.page";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms'
import { MatSnackBar } from '@angular/material/snack-bar';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable'

@Component({
    selector: "Studentreport-page",
    templateUrl: "./Studentreport.page.html", styleUrls: ["../app.component.css"]
})
export class StudentreportPage {
    today: number = Date.now();
    quizid;
    studentdata;
    dialogRef;
    range;
    stdname;
    studentid;
    status;
    evaldata;
    result;
    Assignmentdetails;
    Evaluateform: FormGroup;
    printkey=0;
    Assignmenttitle;
    Sheduledate;
    Asatrtdate;
    Aedndate;
    assgnscore;
    scorevalue = '';
    teachername;
    indvidaulreport;
    indvreport=0;
    reportenable = 0;
    obtainscore;
    length = 10;
    pageSize = 8;
    pageindex=1;
    pageSizeOptions: number[] = [8];
    printdata;

    ngOnInit() {
        this.Evaluateform = this.fb.group({
            acrj: ['', Validators.required],
            feedback: ['', Validators.required],
            Astscore: ['', [Validators.required, Validators.max(this.assgnscore)]]
        });
         
        this.adddata()
        this.teachername = sessionStorage.getItem('teachername');
    if (this.teachername == undefined) {
      this.logout();
    }
    document.getElementById("btnGroupDrop1").innerText = this.teachername;
      }
    adddata(){
        this.Assignmentdetails =  JSON.parse(sessionStorage.getItem("editdata"));
            if(this.Assignmentdetails != null)
            {
            this.Assignmenttitle = this.Assignmentdetails.AssignmentTitle;
            this.Asatrtdate = new Date(this.Assignmentdetails.startdate).toLocaleDateString()
            this.Aedndate  = new Date(this.Assignmentdetails.enddate).toLocaleDateString();            
            this.assgnscore =  this.Assignmentdetails.Score;
            }
    }
    public checkError = (controlName: string, errorName: string) => {
        return this.Evaluateform.controls[controlName].hasError(errorName);
      }
    constructor(private _snackBar: MatSnackBar,private el :ElementRef,private fb: FormBuilder,private router: Router, private QuizService: QuizService, private route: ActivatedRoute, public dialog: MatDialog) {
        
        this.range = new FormGroup({
            start: new FormControl(),
            end: new FormControl()
          });
        this.route.queryParams.subscribe(params => {
            this.quizid = CryptoJS.AES.decrypt((params["qid"]).trim(), 'q').toString(CryptoJS.enc.Utf8);
        });
        this.refreshdata();
       
    }
    refreshdata() {
        setTimeout(() => {
   var jsonobj = [
            {
                "Quizid": this.quizid,
                "pageno": this.pageindex,
                "pagesize": this.pageSize
            }];
        this.QuizService.getsubmittedstudentbyid(JSON.stringify(jsonobj))
            .subscribe(data => {this.studentdata = (JSON.parse(JSON.stringify(data)));
                if(this.studentdata.length>0){
                    this.length=(this.studentdata[0]["totolrows"])
                }else{
                    this.length=0;
                }
            });
        }, 100);
    }

    review(obj) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.width = '90%';
        dialogConfig.height = '80%';
        this.dialogRef = this.dialog.open(StudentresponsePage, dialogConfig);
        sessionStorage.setItem('ReviewOrgJson1',JSON.stringify(JSON.parse(obj)));
    }
    closepopup()
    {
        this.result = null;
        this.Evaluateform = this.fb.group({
            acrj: ['', Validators.required],
            feedback: ['', Validators.required],
            Astscore: ['',[Validators.required, Validators.max(this.assgnscore)]]
            
        });
    }
    Studentidset(sid,sname)
    {
        this.evaldata = null;
        this.Evaluateform.enable();
        sessionStorage.setItem('SID',sid);
        this.stdname = sname;
    }
    Navigateedit(obj) {
        if (obj == "S001") {
          var snackBarRef;
            snackBarRef = this._snackBar.open("Assignment evaluvated successfully", "Ok", {
            });
          snackBarRef.onAction().subscribe(() => {
            this.router.navigate(['/StudentreportPage'])
          });
        }
      }
    savescore(){
        if (!this.Evaluateform.valid) {
            for (const key of Object.keys(this.Evaluateform.controls)) {
                if (this.Evaluateform.controls[key].invalid) {
                  const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
                  invalidControl.focus();
                  break;
               }
          }
              return;
        }
        var jsonobj  = [
          {
            "Result":this.Evaluateform.get('acrj').value,
            "Feedback":this.Evaluateform.get('feedback').value,
            "Score":this.Evaluateform.get('Astscore').value     
          }];
          var updatejson = {
            studentid: sessionStorage.getItem("SID"),
            submittedans: JSON.stringify(jsonobj)        
          }
          this.QuizService.StudentEvaluvation(JSON.stringify(updatejson))
            .subscribe(data => {
                if (data['status'] == "S001") {
                var snackBarRef;
                this.status = data['status'];
                var x = document.getElementById("closeid") as HTMLInputElement; 
                x.click();
                snackBarRef = this._snackBar.open("Assignment evaluated successfully", "Ok", {
                });
                var jsonobj = [
                    {
                        "Quizid": this.quizid,
                        "pageno": this.pageindex,
                        "pagesize": this.pageSize
                    }];
                this.QuizService.getsubmittedstudentbyid(JSON.stringify(jsonobj))
                    .subscribe(data => {this.studentdata = (JSON.parse(JSON.stringify(data))); 
                        if(this.studentdata.length>0){
                        this.length=(this.studentdata[0]["totolrows"])
                    }else{
                        this.length=0;
                    } 
                });
            }
            else
            {
                snackBarRef = this._snackBar.open("Assignment evaluate unsuccessfull", "Ok", {
                }); 
            }

            });
      }
      public onKeydownscore(e): any {
         
        //   this.scorevalue += e.key +'';
        if(!((e.keyCode > 95 && e.keyCode < 106)
        || (e.keyCode > 47 && e.keyCode < 58) 
        || e.keyCode == 8)) {
            
          return false;
      }
    //   else if (Number(this.scorevalue) > this.assgnscore)
    //   return false;

}

onPaginateChange(obj){
    this.pageindex=obj["pageIndex"]+1;
    var jsonobj = [
        {
            "Quizid": this.quizid,
            "pageno": obj["pageIndex"]+1,
            "pagesize": this.pageSize
        }];
        console.log(jsonobj);
    this.QuizService.getsubmittedstudentbyid(JSON.stringify(jsonobj))
        .subscribe(data => {this.studentdata = (JSON.parse(JSON.stringify(data)));
        this.length=(data[0]["totolrows"]);
        });
}

evalinfo(obj,sname)
{
    this.Evaluateform.disable();
    this.stdname = sname;
   this.evaldata = obj;
   this.result =  this.evaldata.Result;
   this.obtainscore = this.evaldata.Score;
    this.Evaluateform.patchValue({
        acrj:this.evaldata.Result,
        feedback: this.evaldata.Feedback,
        Astscore: this.evaldata.Score
      }); 
}

rejectclick()
{
    this.Evaluateform = this.fb.group({
        acrj: [this.Evaluateform.get('acrj').value, Validators.required],
        feedback: [this.Evaluateform.get('feedback').value, Validators.required],
        Astscore: [this.Evaluateform.get('Astscore').value]
        
    });
}
Acceptclick()
{
    this.Evaluateform = this.fb.group({
        acrj: [this.Evaluateform.get('acrj').value, Validators.required],
        feedback: [this.Evaluateform.get('feedback').value, Validators.required],
        Astscore: [this.Evaluateform.get('Astscore').value,[Validators.required, Validators.max(this.assgnscore)]]
        
    });
}
Printreport()
{
    this.printkey =1;
    this.indvreport=0;
    var pagination =  document.getElementById('pagination') as HTMLInputElement
    pagination.style.display ="none";
    var jsonobj = [
        {
            "Quizid": this.quizid,
        }];
    this.QuizService.getsubmittedstudentbyid(JSON.stringify(jsonobj))
        .subscribe(data => {this.printdata = (JSON.parse(JSON.stringify(data))); 
            if(this.printdata.length>0){
            this.length=(this.printdata[0]["totolrows"])
        }else{
            this.length=0; 
        }
        for(var i=0;i<this.printdata.length;i++)
               {
            if(this.printdata[i].Evaluvationdata != undefined)
               {
                this.reportenable = 1;
                break;
               }
               else{
                this.reportenable = 0;
               }
                } 
    });
}
printback()
{
    var pagination =  document.getElementById('pagination') as HTMLInputElement
    pagination.style.display ="block";
    this.printkey =0;
    this.indvreport=0;
}
@ViewChild('reportContent') reportContent: ElementRef;
@ViewChild('reportContent1') reportContent1: ElementRef;
    downloadPdf() {
        var details =  JSON.parse(sessionStorage.getItem("editdata"));
        
        var scheduledate=new Date(details["startdate"]).toLocaleDateString() + " To "  + new Date(details["enddate"]).toLocaleDateString();
        const doc = new jsPDF();
        doc.setFontSize(10);
        const specialElementHandlers = {
            '#editor': function (element, renderer) {
                return true;
            }
        };
        var res;
        if(this.indvreport){
            res = doc.autoTableHtmlToJson(document.getElementById("my-table1"));
            var header = function (data) {
                doc.setFontSize(14);
                doc.setTextColor(40);
                doc.setFontStyle('normal');
                //doc.addImage(headerImgData, 'JPEG', data.settings.margin.left, 20, 50, 50);
                doc.text("Assignment evaluation report", 72, 10);
                doc.setFontSize(12);
            };
        }
        else{
            var header = function (data) {
                doc.setFontSize(14);
                doc.setTextColor(40);
                doc.setFontStyle('normal');
                //doc.addImage(headerImgData, 'JPEG', data.settings.margin.left, 20, 50, 50);
                doc.text("Assignment evaluation report", 72, 10);
                doc.setFontSize(12);
                doc.text("Assignment name : " + details["AssignmentTitle"] + "\tSchedule Date : " +scheduledate, 15, 25);
            };
            res = doc.autoTableHtmlToJson(document.getElementById("my-table"));
        }
            
      

        var options = {
            beforePageContent: header,
            margin: {
                top: 28
            },

            startY: doc.autoTableEndPosY() + 28
        };

        // const content = this.reportContent.nativeElement;

        doc.autoTable(res.columns, res.data, options);

        doc.save("Assignment_report_" + new Date().toLocaleDateString() + '.pdf');
        
    }
    
    Reports(report,stname,stdate)
    {
        this.indvreport =1;
        this.indvidaulreport = [];
this.indvidaulreport = report;
this.indvidaulreport.push(stname);
this.indvidaulreport.push(stdate);
console.log(this.indvidaulreport);
    }
    logout() {
        this.router.navigate(["/"]);
        sessionStorage.clear();
      }
}

